module.exports = __webpack_public_path__ + "static/media/about.1929a7e0.jpg";